module.exports = __webpack_public_path__ + "static/media/sort-circle.112c27cc.svg";